// extracted by mini-css-extract-plugin
export default {"root":"style_root__i7vnz","header":"style_header__amUQ2","content":"style_content__ZuRys","icon":"style_icon__p+LV7","active":"style_active__C+SEE"};